import { render } from "./App.vue?vue&type=template&id=31c910bd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=31c910bd&lang=css"

import exportComponent from "/Users/user/Desktop/personal_projects/openai/python_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__